// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconList: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 12">
            <path
                fill="currentColor"
                d="M13 5H.972C.448 5 0 5.447 0 6s.448 1 .972 1h12C13.553 7 14 6.553 14 6s-.447-1-1-1m0 5H.972a.99.99 0 0 0-.972.972C0 11.497.448 12 .972 12h12c.581 0 1.028-.447 1.028-1s-.447-1-1-1m0-10H.972A.99.99 0 0 0 0 .972C0 1.496.448 2 .972 2h12C13.553 2 14 1.553 14 1s-.447-1-1-1"
            />
        </svg>
    );
};

export default React.memo(IconList);
